import React from 'react';

import { Image } from '@cian/ui-kit/image';
import { TImageObjectFit } from '@cian/ui-kit/image/types';

interface ICarouselPhotoProps {
  src: string;
  objectFit?: TImageObjectFit;
}

const CarouselPhotoComponent: React.FC<ICarouselPhotoProps> = ({ src, objectFit = 'cover' }) => (
  <Image borderRadius={0} src={src} objectFit={objectFit} />
);

export const CarouselPhoto = React.memo(CarouselPhotoComponent);
